import Button from '@liveauctioneers/caterwaul-components/lib/Button/Button';
import { H4 } from '@liveauctioneers/hammer-ui-core/text';
import * as React from 'react';
import styled from 'styled-components';

type Props = {
    readonly houseName: string;
    readonly isHouse?: boolean;
    readonly onBack: (event: React.MouseEvent<HTMLDivElement>) => void;
    readonly testid?: string;
};

const ClosedConversationPrompt = ({
    houseName,
    isHouse,
    onBack,
    testid = 'messengerClosedConversationPrompt',
}: Props) => (
    <>
        <TextContainer data-testid={testid}>
            <H4>This conversation is marked closed.</H4>
            {!isHouse && <H4>Please send {houseName} a new message if you have a question.</H4>}
        </TextContainer>
        <ButtonContainer
            aria-label="Back to inbox"
            onClick={onBack}
        >
            <Button>Back to Inbox</Button>
        </ButtonContainer>
    </>
);

export default ClosedConversationPrompt;

const TextContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    padding: 23px 32px 24px;
    background-color: ${({ theme }) => theme.colors.grey500};
    border: solid 1px ${({ theme }) => theme.colors.grey400};
`;

const ButtonContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin: 20px 0;
`;
